import React from 'react';
import { ListGroup, Col, Row, Button } from 'react-bootstrap';

import DocumentOutline from 'react-ionicons/lib/DocumentOutline';
import ChatbubblesOutline from 'react-ionicons/lib/ChatbubblesOutline';
import { toLongDate } from '../../helpers/Date';
import AppOverlay from '../Overlay/Overlay';
import SkeletonBox from '../SkeletonBox/SkeletonBox';

export const DFLT_ICO_PROPS = {
    height: '24px',
    width:  '24px',
    color: 'inherit'
};

const DriveDocumentItem = ({
    item
}) => {
    // if (!item) return null;
    let displayIcon = <SkeletonBox className="rounded" style={{minWidth: 34, height: 34}} />;
    let filename = <SkeletonBox  style={{minWidth: 120}} />;
    let displayDate = <SkeletonBox style={{ minWidth: 0, maxWidth: 90 }}/>;
    let file = null;
    let type = null;
    if (item && item.activityFeed) {
        const af = item.activityFeed || {};
        const payload = af.payload || {};
        file = payload.file || {};
        filename = ''+file.fileName+''+file.fileExtension;
        type = af.action;
        displayDate = toLongDate(new Date(item.updatedAt));
        displayIcon = (
            type == 'NEW_COMMENT' ? 
            <ChatbubblesOutline {...DFLT_ICO_PROPS} /> :
            <DocumentOutline    {...DFLT_ICO_PROPS} />
        );
    }
    return (
        <ListGroup.Item>
            <Row>
                <Col className="flex-grow-0 d-flex align-items-center justify-content-center col">
                    {displayIcon}
                </Col>
                <Col className="flex-grow-1" style={{paddingTop: '2px'}}>
                    <b>{filename} {type == 'NEW_COMMENT' ? <span className="text-muted">- New comment</span> : null}</b><br/>
                    <span className="text-muted">{displayDate}</span>
                </Col>
                <Col className="flex-grow-0 d-flex align-items-center" style={{paddingTop: '2px'}}>
                    {item ? <Button disabled>View</Button> : <SkeletonBox style={{height: 34, minWidth: 70}} />}
                </Col>
            </Row>
        </ListGroup.Item>
    );
};

const ActivityListGroup = ({
    className = '',
    items
}) => {
    let activityList = null;
    if (Array.isArray(items) && items.length > 0) {
        activityList = items.map(elm => <DriveDocumentItem key={elm.id} item={elm} />)
    }
    else if (Array.isArray(items) && items.length === 0) {
        activityList = <ListGroup.Item className="text-center fw-light">No recent activity</ListGroup.Item>
    } else {
        activityList = (
            <>
                <DriveDocumentItem />
                <DriveDocumentItem />
                <DriveDocumentItem />
                <DriveDocumentItem />
            </>
        )
    }
    return (
        <ListGroup className={className || ''}>
            {activityList}
        </ListGroup>
    );
};

export default ActivityListGroup;
